<div class="filter"> 
  <div class="filter-container" *ngIf="filter">
    <mat-form-field appearance="outline" class="column-field">
      <mat-label>Column</mat-label>
      <mat-select [(value)]="edited.columnValue" (selectionChange)="onColumnChange($event)">
        <mat-option *ngFor="let column of columns" [value]="column.value">
          {{column.displayName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="separator"></div>
    <mat-form-field appearance="outline" (disabled)="!edited || !edited.columnValue" class="operator-field">
      <mat-label>Operator</mat-label>
      <mat-select  [(value)]="edited.operatorValue">
        <mat-option *ngFor="let operator of getSelectedOperators()" [value]="operator.value">
          {{operator.displayName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="separator"></div>
    <mat-form-field  appearance="outline" *ngIf="!edited.columnValue || getValueStyle() === 'text'" (disabled)="!edited ||!edited.columnValue" class="text-input">
        <mat-label>Value</mat-label>
        <input matInput placeholder="Jane Smith" (keyup)="checkExpression($event)" [(ngModel)]="edited.expressionValue">
    </mat-form-field>
  <mat-form-field class="date-picker" appearance="outline" *ngIf="edited && edited.columnValue && getValueStyle() === 'datepicker' && edited.operatorValue && edited.operatorValue != '}' && edited.operatorValue != '~'"  >
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="edited.expressionValue" placeholder="Choose a date">
    <mat-datepicker-toggle matSuffix [startAt]="datePickerDate" [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  </div>
  <div class="icon-buttons" *ngIf="filter">
    <button  (click)="onCancel()" mat-icon-button >
      <mat-icon class="cancel-button">close</mat-icon>
    </button>
    <button *ngIf="numFilters === filter.index + 1" (click)="onSave()" mat-icon-button  >
      <mat-icon class="done-button">done</mat-icon>
    </button>
  </div>
</div>